import { extend } from 'lodash';
import { DateGDT } from '.';
import { SvgCamiseta } from './editProfile';

export interface GenericStateResponse {
  estado: boolean;
  mensaje?: string;
}

export interface SuggestUsersChallengeResponse extends GenericStateResponse {
  usuarios: {
    idUsuario: number;
    nombres: string;
    apellido: string;
    club: string;
    nombreEquipo: string;
    edad: number;
    id: number;
    ganados: number;
    perdidos: number;
    empatados: number;
    fotoPerfil: string;
    fotoPerfilAbsoluta: string;
  }[];
}

export interface ChallengeUser {
  idDesafio: number;
  idUsuarioRival: number;
  apellidoUsuarioRival: string;
  nombreUsuarioRival: string;
  nombreEquipoUsuarioRival: string;
  idUsuarioDesafiador: number;
  hinchaDe: string;
  idEstadoDesafio: number;
  cm: boolean;
  timestamp: string;
  disabled?: boolean;
  ganados?: number;
  perdidos?: number;
  fotoPerfil?: string;
}

export interface ChallengeUserResponse extends GenericStateResponse {
  usuarios: ChallengeUser[];
}

export interface SearchUserResponse extends GenericStateResponse {
  usuarios: UserChallengeSearchTO[];
}

export interface ChallengeInitResponse extends GenericStateResponse {
  estadisticasActuales: ChallengeStatisticsInfo;
  desafios: ChallengeUser[];
  puedeDesafiar: boolean;
  ultimosResultados: InfoCalificacionEquipoTO[];
  fechas: ChallengeDate[];
  ptos_fecha: number;
  user_nombre: string;
  user_equipo: string;
  hist_ganados: number;
  hist_empatados: number;
  hist_perdidos: number;
  hist_jugados: number;
}

export interface DateResultsResponse extends GenericStateResponse {
  ultimosResultados: {
    idUsuario: number;
    puntosTotal: number;
    nombres: string;
    apellido: string;
    nombreEquipoFantasia: string;
    camiseta?: string;
  }[];
  ptos_fecha: number;
  user_nombre: string;
  user_equipo: string;
}

//Diego

export interface ProcessChallengeResponse extends GenericStateResponse {}

export interface ChallengeDate extends DateGDT {
  idRnkPublicado: number;
  publicada: boolean;
}

export interface InfoCalificacionEquipoTO {
  idUsuario: number;
  puntosTotal: number;
  nombres: string;
  apellido: string;
  camiseta?: SvgCamiseta;
  nombreEquipoFantasia: string;
  ptos_fecha?: number;
  user_nombre?: string;
  user_equipo?: string;
}

export const enum ChallengeStatus {
  PENDIENTE = 1,
  CONFIRMADO = 2,
  RECHAZADO = 3,
  PENDIENTE_PUEDE_CONFIRMAR = 4,
}

export interface ChallengeStatisticsInfo {
  confirmados: number;
  pendientesTotal: number;
  pendientesSoyElDesafiado: number;
}

export interface SuggestUserChallengesResponse extends GenericStateResponse {
  usuarios: UserChallengeSearchTO[];
}

export interface UserChallengeSearchTO {
  idUsuario: number;
  nombres: string;
  apellido: string;
  club: string;
  provincia?: string;
  nombreEquipo: string;
  edad: number;
  ganados: number;
  perdidos: number;
  empatados: number;
  fotoPerfil: string;
  id: number;
  fotoPerfilAbsoluta: string;
}

export interface UserChallengeResponse {
  estado: boolean;
  desafio?: ChallengeUser[];
}

export interface ChallengeDateResponseResults {
  ultimosResultados: InfoCalificacionEquipoTO[];
}
